import i18n from '@/localization';

export const DUEL_STATUSES = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
};

export const PREDICTION_LABELS = {
  HIT: i18n.t('labels.predictions.hit'),

  ANY: i18n.t('labels.predictions.any'),
  SINGLE: i18n.t('labels.predictions.single'),
  DOUBLE: i18n.t('labels.predictions.double'),
  TRIPLE: i18n.t('labels.predictions.triple'),
  HOME_RUN: i18n.t('labels.predictions.home_run'),

  OUT: i18n.t('labels.predictions.out'),

  STRIKE_OUT: i18n.t('labels.predictions.strike_out'),

  GROUND_OUT: i18n.t('labels.predictions.ground_out'),
  // ANY: i18n.t('labels.predictions.any'),
  '1B': i18n.t('labels.predictions.1b'),
  '2B': i18n.t('labels.predictions.2b'),
  '3B': i18n.t('labels.predictions.3b'),
  SS: i18n.t('labels.predictions.ss'),
  P: i18n.t('labels.predictions.p'),
  C: i18n.t('labels.predictions.c'),
  GO_ANY_OUTFIELDER: i18n.t('labels.predictions.go_any_outfielder'),

  FLY_OUT: i18n.t('labels.predictions.fly_out'),
  // ANY: i18n.t('labels.predictions.any'),
  LF: i18n.t('labels.predictions.lf'),
  CF: i18n.t('labels.predictions.cf'),
  RF: i18n.t('labels.predictions.rf'),
  // '1B': i18n.t('labels.predictions.1b'),
  // '2B': i18n.t('labels.predictions.2b'),
  // '3B': i18n.t('labels.predictions.3b'),
  // SS: i18n.t('labels.predictions.ss'),
  // P: i18n.t('labels.predictions.p'),
  // C: i18n.t('labels.predictions.c'),

  WALK: i18n.t('labels.predictions.walk'),
};
